import Icon from '../components/Icon.vue'

Icon.register({"ellipsis-v":{"width":192,"height":512,"paths":[{"d":"M96 184C135.8 184 168 216.2 168 256S135.8 328 96 328 24 295.8 24 256 56.2 184 96 184zM24 80C24 119.8 56.2 152 96 152S168 119.8 168 80 135.8 8 96 8 24 40.2 24 80zM24 432C24 471.8 56.2 504 96 504S168 471.8 168 432 135.8 360 96 360 24 392.2 24 432z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ellipsis-v.js
// module id = jd2K
// module chunks = 0